var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6122_24199",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6122_24199)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.938 22.244L31.838 14.144L23.738 6.044C23.09 5.396 22.19 5 21.2 5H8.6C6.62 5 5 6.62 5 8.6V21.2C5 22.19 5.396 23.09 6.062 23.756L22.262 39.956C22.91 40.604 23.81 41 24.8 41C25.79 41 26.69 40.604 27.338 39.938L39.938 27.338C40.604 26.69 41 25.79 41 24.8C41 23.81 40.586 22.892 39.938 22.244ZM11.3 14C9.806 14 8.6 12.794 8.6 11.3C8.6 9.806 9.806 8.6 11.3 8.6C12.794 8.6 14 9.806 14 11.3C14 12.794 12.794 14 11.3 14Z",
    fill: "#233D7A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.ca43105341b5af47329f26805b8927ed.svg";
export { ForwardRef as ReactComponent };